<template>
  <v-card flat class="vehicle defaultPadding mb-2 mt-3">
    <div class="contentLeft">
      <span class="modelo">{{ model }}</span>
      <br />
      <img
        class="vehicleImg"
        style="max-width: 186px; height: auto"
        :src="`${url_bucket}${url}`"
      />
      <br />
      <span class="body-1 total">Placa:</span>
      <span class="pl-2 body-1 total">{{ plate }}</span>
      <br />
    </div>
    <div class="contentRight pt-2 pl-2">
      <div class="pb-1">
        <img src="../../assets/icons/icon2.png" />
        <span class="pl-2 caption">{{ gearbox }}</span>
      </div>
      <div class="pb-1">
        <img src="../../assets/icons/icon3.png" />
        <span class="pl-2 caption">Álcool</span>
      </div>
      <div class="pb-1">
        <img src="../../assets/icons/icon4.png" />
        <span class="pl-2 caption">{{ doors_qtd }} Portas</span>
      </div>
      <div class="pb-1">
        <img src="../../assets/icons/icon5.png" />
        <span class="pl-2 caption">Ar Condicionado</span>
      </div>
    </div>
  </v-card>
</template>
<script>
import Constants from "../../models/constants/Constants";
export default {
  props: {
    model: { type: String, required: true },
    url: { type: String, required: true },
    plate: { type: String, required: true },
    gearbox: { type: String, required: true },
    doors_qtd: { type: Number, required: true },
  },
  data() {
    return { url_bucket: Constants.URL_BUCKET_PICKNDRIVE };
  },
};
</script>
